<div *ngIf="!rentalConfig.allowFixedRentalOptions && !rentalConfig.allowFlexibleRentalOptions">
  <div class="no-availabiliy-configured">
    {{'bikeshop.rentals.booking.availability_rentals_error' | translate }}
  </div>
</div>

<div class="availability-container margin-top-16"
     *ngIf="rentalConfig.allowFixedRentalOptions || rentalConfig.allowFlexibleRentalOptions">
  <div>
    <div class="label" [ngClass]="{'red': !reservation.reservationDate || !reservation.selectedSlot}">
      <div>
        *{{ 'bikeshop.rentals.booking.pickup' | translate }}
      </div>
    </div>

    <div class="date-time-picker-container">
      <div>
        <div>
          <p-calendar #calendar [(ngModel)]="reservation.reservationDate"
                      [minDate]="minDate"
                      [defaultDate]="minDate"
                      [readonlyInput]="false"
                      (onSelect)="dateSelected($event)"
                      [disabledDates]="disabledDates"
                      (onMonthChange)="monthChanged($event)"
                      [showOtherMonths]="false"
                      [dateFormat]="countryData.datePickerFormat"
                      placeholder="{{'bikeshop.rentals.booking.select_date' | translate}}"
          ></p-calendar>
          <span class="fa fa-calendar"></span>
        </div>

      </div>
      <div>
        <div>
          <p-dropdown
            [options]="availableSlots"
            [ngModel]="reservation.selectedSlot"
            optionLabel="label"
            (onChange)="slotSelected($event)"
            placeholder="{{'bikeshop.rentals.booking.select_time' | translate}}"
            [disabled]="!reservation.reservationDate || loadingAvailability  && (reservation.cart === undefined || reservation.cart.length ===0)">
            <ng-template let-slot pTemplate="slot">
              <div>
                <span>{{ slot.label }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="rentalConfig.allowFixedRentalOptions && !rentalConfig.allowFlexibleRentalOptions">
    <div class="label" [ngClass]="{'red': !reservation.selectedDuration}">
      <div>
        *{{ 'bikeshop.rentals.booking.duration' | translate }}
      </div>
      <div></div>
    </div>

    <div class="duration-picker-container">
      <div>
        <div>
          <p-dropdown
            [options]="reservation.selectedSlot && reservation.selectedSlot.durations ? reservation.selectedSlot.durations : []"
            [ngModel]="reservation.selectedDuration"
            optionLabel="label"
            (onChange)="durationSelected($event, true)"
            placeholder="{{'bikeshop.rentals.booking.select_duration' | translate}}"
            [disabled]="!reservation.reservationDate || !reservation.selectedSlot || loadingAvailability  && (reservation.cart === undefined || reservation.cart.length ===0)">
            <ng-template let-duration pTemplate="duration">
              <div>
                <span>{{ duration.label }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="rentalConfig.allowFlexibleRentalOptions">
    <div class="label"
         [ngClass]="{'red': !reservation.reservationReturnDate || !(reservation.selectedDuration || reservation.selectedReturnSlot)}">
      <div>
        *{{ 'bikeshop.rentals.booking.return' | translate }}
      </div>
      <div></div>
    </div>

    <div class="date-time-picker-container">
      <div>
        <div>
          <p-calendar #calendarReturn [(ngModel)]="reservation.reservationReturnDate"
                      [minDate]="minReturnDate"
                      [maxDate]="maxReturnDate"
                      [defaultDate]="reservation.reservationDate"
                      [readonlyInput]="true"
                      [disabledDays]="reservation.reservationDate && reservation.selectedSlot ? [] : [1,2,3,4,5,6,0]"
                      (onSelect)="returnDateSelected($event)" [disabledDates]="disabledReturnDates"
                      (onMonthChange)="returnMonthChanged($event)" [showOtherMonths]="false"
                      [dateFormat]="countryData.datePickerFormat"
                      placeholder="{{'bikeshop.rentals.booking.select_date' | translate}}">
          </p-calendar>
          <span class="fa fa-calendar"></span>
        </div>

      </div>
      <div>
        <div *ngIf="rentalConfig.allowFixedRentalOptions && isSameDayBooking()">
          <p-dropdown
            [options]="reservation.selectedSlot && reservation.selectedSlot.durations ? reservation.selectedSlot.durations : []"
            [ngModel]="reservation.selectedDuration"
            optionLabel="label"
            (onChange)="durationSelected($event, true)"
            placeholder="{{'bikeshop.rentals.booking.select_duration' | translate}}"
            [disabled]="!reservation.reservationDate || !reservation.selectedSlot || loadingAvailability">
            <ng-template let-duration pTemplate="duration">
              <div>
                <span>{{ duration.label }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div *ngIf="!(rentalConfig.allowFixedRentalOptions && isSameDayBooking())">
          <p-dropdown
            [options]="availableReturnSlots"
            [ngModel]="reservation.selectedReturnSlot"
            optionLabel="label"
            (onChange)="slotReturnSelected($event, true)"
            placeholder="{{'bikeshop.rentals.booking.select_time' | translate}}"
            [disabled]="!reservation.reservationReturnDate || !reservation.reservationDate || loadingAvailability">
            <ng-template let-slot pTemplate="slot">
              <div>
                <span>{{ slot.label }} </span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
    </div>

  </div>
</div>

<div *ngIf="reservation.useFlexibleTimes && reservation.selectedReturnSlot" class="rental-days-message">
  <div
    *ngIf="rentalDaysMessage==='EXACT' || rentalDaysMessage==='UNDER' ">{{ 'bikeshop.rentals.booking.days_reserved_exact' | translate : {days: reservation.rentalDays} }}</div>
  <div *ngIf="rentalDaysMessage==='OVER'">{{ 'bikeshop.rentals.booking.days_reserved_over' | translate : {
    days: reservation.rentalDays,
    time: reservation.selectedSlot.label
  } }}</div>
  <!-- <div *ngIf="rentalDaysMessage==='UNDER'">{{ 'bikeshop.rentals.booking.days_reserved_under' | translate : {days: reservation.rentalDays, time: reservation.selectedSlot.label} }}</div> -->
</div>

<div *ngIf="loadingAvailability" class="spinner">
  <p-progressSpinner strokeWidth="2" [style]="{width: '30px', height: '30px'}"></p-progressSpinner>
</div>
